import { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ICArrowLefLarge32: FC<PropsT> = ({ fill = '#FEFEFE' }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.7207 23.3802L13.3025 16L20.7207 8.61976C21.0931 8.24922 21.0931 7.64844 20.7207 7.2779C20.3482 6.90736 19.7443 6.90737 19.3719 7.27791L11.2793 15.3291C10.9069 15.6996 10.9069 16.3004 11.2793 16.6709L19.3719 24.7221C19.7443 25.0926 20.3482 25.0926 20.7207 24.7221C21.0931 24.3516 21.0931 23.7508 20.7207 23.3802Z"
        fill={fill}/>
    </svg>

  );
}

export default ICArrowLefLarge32;
import { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ICArrowLefLarge32: FC<PropsT> = ({ fill = '#FEFEFE' }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.7207 23.3802L13.3025 16L20.7207 8.61976C21.0931 8.24922 21.0931 7.64844 20.7207 7.2779C20.3482 6.90736 19.7443 6.90737 19.3719 7.27791L11.2793 15.3291C10.9069 15.6996 10.9069 16.3004 11.2793 16.6709L19.3719 24.7221C19.7443 25.0926 20.3482 25.0926 20.7207 24.7221C21.0931 24.3516 21.0931 23.7508 20.7207 23.3802Z"
        fill={fill}/>
    </svg>

  );
}

export default ICArrowLefLarge32;
